import { axiosInstance } from '../clients/axiosClient';
import { CLINICS_API_PREFIX, API_V1_PREFIX } from '../utils/constants';
import {
  CreateClinicRequestPydantic,
  CreateClinicResponse,
  GetClinicResponse,
  HTTPValidationError,
  ListClinicsResponse,
  UpdateClinicRequestPydantic,
  UpdateClinicResponse,
} from '../types/apiGeneratedTypes';

export const getClinicsList = async (
  offset: number = 0,
  limit: number = 10,
  sort_by?: string,
  sort_direction?: 'asc' | 'desc'
): Promise<ListClinicsResponse> => {
  try {
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
    });

    if (sort_by) {
      params.append('sort_field', sort_by);
    }
    if (sort_direction) {
      params.append('sort_order', sort_direction);
    }

    const url = `${API_V1_PREFIX}${CLINICS_API_PREFIX}list?${params.toString()}`;
    console.log('Making clinics API call to:', url);
    console.log('Sort parameters:', { sort_by, sort_direction });

    const { data } = await axiosInstance.get(url);

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const createClinic = async (
  newClinicRequestObject: CreateClinicRequestPydantic
): Promise<CreateClinicResponse | HTTPValidationError> => {
  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${CLINICS_API_PREFIX}`,
      newClinicRequestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const updateClinic = async (
  clinicRequestObject: UpdateClinicRequestPydantic
): Promise<UpdateClinicResponse | HTTPValidationError> => {
  try {
    const { data } = await axiosInstance.patch(
      `${API_V1_PREFIX}${CLINICS_API_PREFIX}`,
      clinicRequestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getClinic = async (id: string): Promise<GetClinicResponse> => {
  try {
    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${CLINICS_API_PREFIX}${id}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
